<img (click)="OnClick($event)" [src]="imgPath" [ngClass]="imgClasses" />
